import React from "react";

import GetStartedForm from "./../templates/getStartedForm";

import SpruceImage from "./../images/clientLogos/spruce.png";
import BrownlivingImage from "./../images/clientLogos/brownliving.png";
import GynovedaImage from "./../images/clientLogos/gynoveda.png";

export default function HeroSection(props) {
  return (
    <div className="relative max-w-7xl mx-auto overflow-hidden heroSection" style={{ backgroundImage: props.background ? ` linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)), url(${props.background})` : "none", backgroundSize: "cover" }}>
      {props.heavyBackground && (
        <div className="hidden lg:block lg:absolute lg:inset-0" aria-hidden="true">
          <svg className="absolute top-0 left-1/2 transform translate-x-64 -translate-y-8" width={640} height={784} fill="none" viewBox="0 0 640 784">
            <defs>
              <pattern id="9ebea6f4-a1f5-4d96-8c4e-4c2abf658047" x={118} y={0} width={20} height={20} patternUnits="userSpaceOnUse">
                <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect y={72} width={640} height={640} className="text-gray-50" fill="currentColor" />
            <rect x={118} width={404} height={784} fill="url(#9ebea6f4-a1f5-4d96-8c4e-4c2abf658047)" />
          </svg>
        </div>
      )}
      {props.lightBackground && (
        <div className="sm:block sm:absolute sm:inset-0 px-5 md:px-0" aria-hidden="true">
          <svg className="absolute bottom-0 right-0 transform translate-x-1/2 mb-48 text-gray-200 lg:top-0 lg:mt-28 lg:mb-0 xl:transform-none xl:translate-x-0" width={364} height={384} viewBox="0 0 364 384" fill="none">
            <defs>
              <pattern id="eab71dd9-9d7a-47bd-8044-256344ee00d0" x={0} y={0} width={20} height={20} patternUnits="userSpaceOnUse">
                <rect x={0} y={0} width={4} height={4} fill="currentColor" />
              </pattern>
            </defs>
            <rect width={364} height={384} fill="url(#eab71dd9-9d7a-47bd-8044-256344ee00d0)" />
          </svg>
        </div>
      )}
      <div className="relative pt-0 md:pt-6 pb-8 md:pb-16 px-5 md:px-0">
        <main className="mt-12 md:mt-10">
          <div className="mx-auto max-w-7xl">
            <div className="lg:grid lg:grid-cols-12 lg:gap-2">
              <div className="sm:px-6 md:px-0 md:max-w-2xl md:mx-auto lg:col-span-6 sm:text-center lg:text-left lg:flex lg:items-center">
                <div className="break-words text-gray-800 text-center md:text-left">
                  <h1>
                    <span className="mt-1 font-bold md:font-extrabold md:text-5xl xl:text-5xl titleText">
                      {props.title1} {props.divideTitlesInNewLine && <br />}{" "}
                    </span>
                    <span className="mt-1 inline md:block font-bold md:font-extrabold md:text-5xl xl:text-5xl titleText">{props.title2}</span>

                    {/* <span className="mt-1 inline md:block text-5xl font-bold sm:text-5xl xl:text-6xl text-primary-600"></span> */}
                  </h1>
                  <p className={`mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-sm xl:text-xl ${props.paddingRight ? props.paddingRight : ""}`}>{props.description}</p>

                  <div>
                    <GetStartedForm></GetStartedForm>
                  </div>

                  {/* Desktop Trusted By */}
                  <div className="hidden md:block">
                    <p className="mt-8 text-sm text-gray-600 uppercase tracking-wide font-semibold sm:mt-10">Trusted by</p>
                    <div className="mt-3 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                      <div className="flex flex-wrap items-start justify-between">
                        <div className="flex justify-center px-1">
                          <img className="h-8" src={SpruceImage} alt="StaticKit" />
                        </div>
                        <div className="flex justify-center px-1">
                          <img className="h-8" src={GynovedaImage} alt="Tuple" />
                        </div>
                        <div className="flex justify-center px-1">
                          <img className="h-9" src={BrownlivingImage} alt="Workcation" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4 md:mt-16 lg:mt-0 lg:col-span-6">
                <img src={props.image}></img>
              </div>

              {/* Mobile Trusted By */}
              <div className="block md:hidden">
                <p className="mt-10 text-sm text-gray-600 uppercase tracking-wide font-semibold sm:mt-10">Trusted by</p>
                <div className="mt-3 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-6 md:h-10" src={SpruceImage} alt="Tuple" />
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-6 md:h-10" src={GynovedaImage} alt="Workcation" />
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-6 md:h-10" src={BrownlivingImage} alt="StaticKit" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
